import { COUNTRY_SHORTCODES } from '../../../constants'
import * as Exp from '../../../experimentConstants'

export const shouldSwapToNCCBackgroundCheckStep = (country, experiments) => {
  const isAU = country === COUNTRY_SHORTCODES.AU
  const isNZ = country === COUNTRY_SHORTCODES.NZ

  const shouldSwapForNZ = isNZ && experiments[Exp.DX_ONBOARDING_V2]

  return isAU || shouldSwapForNZ
}

export const shouldCountryShowBankModal = country => {
  const shouldNotShowCountryList = [COUNTRY_SHORTCODES.NZ]
  return !shouldNotShowCountryList.includes(country)
}

export const shouldShowAbnStep = (country, experiments) => {
  const isAU = country === COUNTRY_SHORTCODES.AU

  return isAU && experiments[Exp.DX_AU_ABN_REPOSITION]
}
